export default __webpack_public_path__ + "static/media/Image-2.d0138708.jpg";